import { render, staticRenderFns } from "./allzhaobiao.vue?vue&type=template&id=94285288&scoped=true&"
import script from "./allzhaobiao.vue?vue&type=script&lang=js&"
export * from "./allzhaobiao.vue?vue&type=script&lang=js&"
import style0 from "./allzhaobiao.vue?vue&type=style&index=0&id=94285288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94285288",
  null
  
)

export default component.exports